// extracted by mini-css-extract-plugin
module.exports = {"button":"AppointmentFailure-module__button___3OejK","message":"AppointmentFailure-module__message___lBY7G"};